import { DatePicker } from '@mui/x-date-pickers';
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from 'components/dataTableableEdit/BaseDataTableEdit';
import { Label } from "components/input/Label";
import dayjs from 'dayjs';
import Pessoa from 'model/administracao/cadastro/Pessoa';
import Produto from 'model/administracao/cadastro/produto/Produto';
import ItemPedido from 'model/producao/ItemPedido';
import Pedido from 'model/producao/Pedido';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Column, ColumnEditorOptions } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { useLoadingContext } from 'provider/LoadingProvider';
import { useContext, useEffect, useState } from "react";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import PedidoService from 'service/producao/PedidoService';
import { pessoaCompleteMethod, pessoaItemTemplate, produtoCompleteMethod, produtoItemTemplate } from 'utils/autocompleteUtils';
import { converterDataHora } from 'utils/convert';

import AuthContext from 'contexts/AuthContext';
import { Dropdown } from 'primereact/dropdown';
import NotaFiscalSaidaService from 'service/vendas/NotaFiscalSaidaService';
import { OpcoesEmissaoNotaFiscalSaida } from 'model/vendas/EmitirNotaFiscalSaida';
const pedidoService = new PedidoService();

export default function PedidoCadastro() {

    const navigate = useNavigate();
    const { acoes } = useContext(AuthContext);
    const podeFaturar = acoes.some(acao => acao.sigla === 'NOTA_FISCAL_SAIDA_GERENCIAR');
    const [opcoesFiscais, setOpcoesFiscais] = useState<OpcoesEmissaoNotaFiscalSaida | null>(null);
    const [queryParameters] = useSearchParams();

    const { setError, control, register, clearErrors, setFocus, formState: { errors } } = useForm();

    const [pedido, setPedido] = useState<Pedido>(new Pedido());
    const [titulo, setTitulo] = useState<string>('Pedido');

    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);

    const [clientes, setClientes] = useState<any[]>([]);
    const [clientesFiltrados, setClientesFiltrados] = useState<any[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        if (!podeFaturar) return;
        let ativo = true;
        new NotaFiscalSaidaService().opcoesEmissao().then(dados => {
            if (ativo) setOpcoesFiscais(dados);
        }).catch(() => {
            if (ativo) msgErro('Dados para faturamento', 'Não foi possível carregar os cadastros fiscais.');
        });
        return () => { ativo = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [podeFaturar]);


    useEffect(() => {
        pedidoService.clientes().then((response) => {
            setClientes(response);
        }).catch((err) => {
            msgErro('Erro ao buscar clientes', err);
        });

        pedidoService.produtos().then((response) => {
            setProdutos(response);
        }).catch((err) => {
            msgErro('Erro ao buscar produtos', err);
        });
    }, []);

    function validar() {
        if (!pedido.cliente || !pedido.cliente.id) {
            setError("cliente", { type: "manual", message: "Cliente é Obrigatório" }, { shouldFocus: true });
            msgAlerta('Cliente', 'Cliente é obrigatório');
            return false;
        }
        if (!pedido.dataPrevista) {
            setError("dataPrevista", { type: "manual", message: "Data Prevista é Obrigatória" }, { shouldFocus: true });
            msgAlerta('Data Prevista', 'Data prevista é obrigatória');
            return false;
        }
        if (pedido.dataPrevista < dayjs(dayjs(new Date()).format("yyyy-mm-dd")).toDate()) {
            msgAlerta('Data Prevista', 'Data prevista não pode ser menor que a data atual');
            return false;
        }

        return true;
    }

    const editorProduto = (options: any) => {
        return <AutoComplete
            value={options.rowData.produto}
            disabled={pedido.status === 'FECHADO'}
            placeholder="Selecione um Produto"
            style={{ width: '100%' }}
            field="nome"
            itemTemplate={(item: Produto) => produtoItemTemplate(item)}
            suggestions={produtosFiltrados}
            completeMethod={(e) => {
                let filtered = produtoCompleteMethod(produtos, e.query);
                setProdutosFiltrados(filtered);
            }}
            onChange={(e) => {
                let pedidoLocal = JSON.parse(JSON.stringify(pedido));
                if (typeof e.target.value == "string") {
                    let prod = new Produto();
                    prod.nome = e.target.value;
                    pedidoLocal.itens[options.rowIndex].produto = prod;
                } else {
                    pedidoLocal.itens[options.rowIndex].produto = e.target.value;
                }
                console.log(pedidoLocal)
                options.rowData['produto'] = pedidoLocal.itens[options.rowIndex].produto;

                setPedido(pedidoLocal);
            }}

        />

    }

    const editorQuantidade = (options: any) => {
        return <InputNumber
            disabled={pedido.status === 'FECHADO'}
            value={options.rowData.qtPedida}
            minFractionDigits={1}
            maxFractionDigits={8}
            maxLength={12}
            locale="pt-BR"
            useGrouping={false}
            onChange={(e) => {
                options.rowData['qtPedida'] = e.value;
                let pedidoLocal = { ...pedido };
                pedidoLocal.itens[options.rowIndex] = options.rowData;
                setPedido(pedidoLocal);
            }}
            style={{ width: '100%' }} />;
    }

    const editorValorUnitario = (options: ColumnEditorOptions) => {
        return <InputNumber value={options.rowData.precoUnitario}
            disabled={pedido.status === 'FECHADO'}
            onChange={(e) => {
                options.rowData['precoUnitario'] = e.value;
                let pedidoLocal = { ...pedido };
                pedidoLocal.itens[options.rowIndex] = options.rowData;
                setPedido(pedidoLocal);

            }} style={{ width: '100%' }} inputStyle={{ width: '100%' }}
            locale='pt-BR' useGrouping={false}
            minFractionDigits={2} maxFractionDigits={2} maxLength={10}
            currency='BRL' mode='currency'
        />
    }

    const botoesExtra = <>
        {podeFaturar &&
            <Button label="Faturar itens" icon="pi pi-file" disabled={!pedido.id || pedido.status !== 'FECHADO'}
                onClick={() => navigate(`/notaFiscalSaida/emitir?pedido=${pedido.id}`)} style={{ marginLeft: 8 }} />}
        <Button label="Fechar Pedido" onClick={() => salvar(fechar)} style={{ marginLeft: 8 }} />
        <Button label="Reabrir Pedido" onClick={() => reabrir()} style={{ marginLeft: 8 }} />
    </>

    function salvar(sucesso: () => void) {
        if (pedido.id) {
            startLoading();
            pedidoService.editar(pedido).then((data) => {
                stopLoading();
                sucesso();
            }).catch((error) => {
                stopLoading();
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro("Pedido", error.data.message);
                } else {
                    msgErro("Pedido", "Ocorreu um erro ao salvar, tente novamente!");
                }
            });
        } else {
            msgAlerta("Pedido", "É necessário salvar o pedido!");
        }

    }

    const fechar = () => {
        pedidoService.fechar(pedido.id).then(() => {
            pedido.status = 'FECHADO';
            setPedido({ ...pedido });
            msgSucesso('Pedido Fechado', 'Pedido fechado com sucesso');
        }).catch((err) => {
            msgErro('Erro ao reabrir pedido', err?.data?.message || "");
        });
    }

    const reabrir = () => {
        pedidoService.reabrir(pedido.id).then(() => {
            pedido.status = 'ABERTO';
            setPedido({ ...pedido });
            msgSucesso('Pedido Reaberto', 'Pedido reaberto com sucesso');
        }).catch((err) => {
            msgErro('Erro ao reabrir pedido', err?.data?.message || "");
        });

    }



    return (

        <BaseCadastro model={pedido} service={pedidoService} botoesExtra={botoesExtra} setModel={(value: Pedido) => setPedido(value)} validar={() => validar()} urlService="/pedido" pathCadastro="/pedido" tituloPagina={'Pedido'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Cliente</Label>
                <div className="col-sm-12">
                    <Controller name="cliente" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            disabled={pedido.status === 'FECHADO'}
                            dropdown
                            value={pedido.cliente}
                            placeholder="Selecione o Cliente"
                            style={{ width: '50%' }}
                            className={errors.cliente ? "p-invalid" : ""}
                            field="nome"
                            itemTemplate={(item: Pessoa) => pessoaItemTemplate(item)}
                            suggestions={clientesFiltrados}
                            completeMethod={(e) => {
                                let filtered: Pessoa[] = pessoaCompleteMethod(clientes, e.query);
                                setClientesFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                clearErrors("cliente")

                                let pedidoLocal = JSON.parse(JSON.stringify(pedido));

                                if (!e.target.value) {
                                    pedidoLocal.cliente = null;
                                } else if (typeof e.target.value == "string") {
                                    let cliente = new Pessoa();
                                    cliente.nome = e.target.value;
                                    pedidoLocal.cliente = cliente;
                                } else {
                                    pedidoLocal.cliente = e.target.value;
                                }

                                setPedido(pedidoLocal);
                            }}
                        />
                    )} />
                </div>
                {errors.cliente && errors.cliente.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.cliente?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Número do Pedido</Label>
                <div className="col-sm-12">
                    <InputNumber value={pedido.numeroPedido} disabled />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Status</Label>
                <div className="col-sm-12">
                    <InputText value={pedidoService.getStatus(pedido.status)} disabled />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Data e Hora de geração</Label>
                <div className="col-sm-12">
                    <InputText value={converterDataHora(pedido.dataHoraGeracao)} disabled />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Data prevista</Label>
                <div className="col-sm-12">
                    <Controller name="dataPrevista" control={control} render={({ field }) => (

                        <DatePicker
                            inputRef={field.ref}
                            disabled={pedido.status === 'FECHADO'}
                            value={dayjs(pedido.dataPrevista)}
                            onChange={value => {
                                clearErrors("dataPrevista")
                                setPedido({ ...pedido, dataPrevista: value?.startOf("day").toDate() || null })
                            }}
                        />
                    )} />
                </div>
                {errors.dataPrevista && errors.dataPrevista.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataPrevista?.message as string}</span> : null}
            </div>

            {opcoesFiscais && <div className="row">
                <div className="col-sm-6 mb-3"><Label>Unidade para faturamento</Label>
                    <Dropdown value={pedido.unidadeOrganizacional?.id ?? null} options={opcoesFiscais.unidades}
                        optionLabel="nome" optionValue="id" filter showClear disabled={pedido.status === 'FECHADO'}
                        onChange={e => setPedido({ ...pedido, unidadeOrganizacional: opcoesFiscais.unidades.find(u => u.id === e.value) ?? null })} className="w-100" /></div>
                <div className="col-sm-6 mb-3"><Label>Representante</Label>
                    <Dropdown value={pedido.representante?.id ?? null} options={opcoesFiscais.representantes}
                        optionLabel="nome" optionValue="id" filter showClear disabled={pedido.status === 'FECHADO'}
                        onChange={e => setPedido({ ...pedido, representante: opcoesFiscais.representantes.find(r => r.id === e.value) ?? null })} className="w-100" /></div>
                <div className="col-sm-6 mb-3"><Label>Condição de pagamento</Label>
                    <Dropdown value={pedido.condicaoPagamento?.id ?? null} options={opcoesFiscais.condicoesPagamento}
                        optionLabel="descricao" optionValue="id" filter showClear disabled={pedido.status === 'FECHADO'}
                        onChange={e => setPedido({ ...pedido, condicaoPagamento: opcoesFiscais.condicoesPagamento.find(c => c.id === e.value) ?? null })} className="w-100" /></div>
                <div className="col-sm-6 mb-3"><Label>Forma de pagamento</Label>
                    <Dropdown value={pedido.formaPagamento?.id ?? null} options={opcoesFiscais.formasPagamento}
                        optionLabel="descricao" optionValue="id" filter showClear disabled={pedido.status === 'FECHADO'}
                        onChange={e => setPedido({ ...pedido, formaPagamento: opcoesFiscais.formasPagamento.find(f => f.id === e.value) ?? null })} className="w-100" /></div>
            </div>}

            <div className="row">
                <Label className="col col-sm-12">Itens</Label>
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Itens"
                        getNewModel={() => new ItemPedido()}
                        dataKey="key"
                        lista={pedido.itens ? pedido.itens : []}
                        setLista={(value: any) => setPedido({ ...pedido, itens: value })}
                        scrollable
                        scrollHeight='500px'
                        addButtonDisabled={pedido.status === 'FECHADO'}
                        showDelete={pedido.status !== 'FECHADO'}
                        showEdit={pedido.status !== 'FECHADO'}
                    >
                        <Column field="produto.nome" header="Produto" editor={editorProduto} />
                        <Column field="qtPedida" header="Quantidade" editor={editorQuantidade} />
                        <Column field="qtFaturada" header="Quantidade faturada" />
                        <Column header="Faturamento" body={(item: ItemPedido) => !item.qtFaturada ? 'Pendente'
                            : item.qtFaturada >= item.qtPedida ? 'Total' : 'Parcial'} />
                        <Column field="precoUnitario" header="Valor Unitário" editor={editorValorUnitario} />
                        <Column header="Valor Total" body={(rowData) => `R$${(rowData.qtPedida * rowData.precoUnitario | 0).toFixed(2)}`} />
                        <Column field="status" header="Status" body={(rowData) => pedidoService.getStatusItem(rowData.status)} />
                    </BaseDataTableEdit>
                </div>
            </div>

        </BaseCadastro>
    )
}
